import React from "react"
import { Account, FinancedObject } from "@sb1finans/new-api/dist/api"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { Card } from "../components/Card"
import { FormattedCurrency } from "@sb1finans/components/dist/FormattedCurrency"
import { CarIcon } from "../components/Icons"
import { AccountWithObject } from "../providers/AccountProvider"

interface AccountInfo {
    account: Account
    accountObject: FinancedObject[]
}

interface AccountProps {
    accounts: AccountInfo[]
}

interface AccountListProps {
    accounts: AccountWithObject[]
    onSelectAccount: (account: Account) => void
}

export const AccountList: React.FC<AccountListProps> = ({accounts, onSelectAccount}) => {

    const onAccountClick = (account: Account) => () => {
        console.log("CLICKED ACCOUNT: ", account)
        onSelectAccount(account)
    }

    return (
        <Stack spacing={2}>
            <Typography variant="h5" sx={{color: "#002776"}}>Mine lån</Typography>
            {
                accounts.map((account) => (
                    <Card
                        key={account.account.id}
                        icon={<CarIcon />}
                        title={account.objects?.[0]?.description ?? ""} 
                        onClick={onAccountClick(account.account)}
                        subtitle={<FormattedCurrency round={true}>{Math.abs(parseInt(account.account.bookedBalance))}</FormattedCurrency>} />
                ))
            }
        </Stack>
    )
}
/*
export const AccountPage: React.FC = () => {
    const {path} = useRouteMatch()
    const {accounts} = useAccountContext()
    
    console.log("PATH IS: ", path)
    return (
        <Switch>
            <Route exact path={path}>
                <Redirect to={`${path}/${accounts[0]?.account?.id}`} />
            </Route>
            <Route path={`:accountId`}>
                <AccountOverviewLg accounts={accounts} />
            </Route>
        </Switch>
    )
}

interface AccountOverviewLgProps {
    accounts: AccountWithObject[]
}

export const AccountOverviewLg: React.FC<AccountOverviewLgProps> = ({accounts}) => {

    console.info("IN ACCOUNTOVERVIRELG")
    const [activeAccount, setActiveAccount] = useState<string>("10")
    const [submenuSelection, setSubmenuSelection] = useState<string | null>("transactions")

    const handleChangeAccount = (event: SelectChangeEvent<string>) => {
        setActiveAccount(event.target.value)
    }

    const handleChangeMenuSelection = (event: React.MouseEvent<HTMLElement>, newSelection: string | null) => {
        console.log(newSelection)
        if (newSelection) {
            setSubmenuSelection(newSelection)
        }
    }

    const renderContent = () => {
        switch (submenuSelection) {
            case "transactions":
                return <AccountTransactionListLg />
            case "invoices":
                return <AccountInvoices />
            default:
                return <PaymentPlanWithData />//<AccountPaymentPlan payments={[]} loading={false} error={null} />
        }
    }

    return (
        <>
            <Stack spacing={4} alignItems="center">
                <FormControl>
                    <InputLabel id="demo-simple-select-label">Konto</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={activeAccount}
                      label="Konto"
                      onChange={handleChangeAccount}
                    >
                        {
                            accounts.map((account) => (
                                <MenuItem value={"10"}>
                                  <Stack  direction="row" justifyContent="space-between">
                                      <Stack>
                                          <Typography variant="body1">{account.objects[0]?.brand}</Typography>
                                          <Typography variant="body2" sx={{color: "#002776"}}>{`Reg. nr: ${account.objects[0]?.registrationNumber}`}</Typography>
                                      </Stack>
                                      <Typography variant="body2" sx={{color: "#002776"}} alignSelf="center"><FormattedCurrency>{parseFloat(account.account.bookedBalance)}</FormattedCurrency></Typography>
                                  </Stack>
                                </MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
                <Typography variant="h5" sx={{color: "#002776"}}>Saldo: kr 98 673</Typography>
                <ToggleButtonGroup value={submenuSelection} exclusive onChange={handleChangeMenuSelection} aria-label="Undermeny">
                  <ToggleButton value="transactions">Transaksjoner</ToggleButton>
                  <ToggleButton value="invoices">Fakturaer</ToggleButton>
                  <ToggleButton value="paymentplan">Betalingsplan</ToggleButton>
                </ToggleButtonGroup>
            </Stack>
            <Box sx={{height: "16px", overflowX: "auto"}} />
            { renderContent() }
        </>
    )
}

const AccountTransactionListLg = () => {

    const agreementId = "221f2d59-d91f-4a42-b7dc-9efc0ca2c0b0"
    const {accountsApi} = useApiContext()

    const [transactions, setTransactions] = useState<Transaction[]>([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<Error | null>(null)

    const fetchTransactions = async () => {
        try {
            const transactionsResponse = await accountsApi.listAccountTransactions(agreementId, "23a543d9-6435-d35f-b9f8-a759c1e1b8c0", {timeout: 60000})
            setTransactions(transactionsResponse.data)
        } catch (error: any) {
            setError(error)
        } finally {
            setLoading(false)
        }
    }

    const mapTypeToDescription = (type: TransactionTransactionTypeEnum) => {
        switch (type) {
            case TransactionTransactionTypeEnum.Installment:
                return "Innbetalt avdrag"
            case TransactionTransactionTypeEnum.IncurredInterest:
                return "Påløpt rente"
            case TransactionTransactionTypeEnum.Payment:
                return "Innbetaling"
            default:
                return "Ukjent"
        }
    }

    useEffect(() => {
        fetchTransactions()
    }, [])

    const transactionGroup = transactions.reduce((acc, transaction) => {
        transaction.invoiceNo = transaction.invoiceNo ?? ""
        acc[transaction.invoiceNo] = acc[transaction.invoiceNo] || []
        acc[transaction.invoiceNo].push(transaction)
        return acc
        //acc[invoiceID] = (acc[invoiceID] || []).concat(transaction)
        //return acc
    }, {} as {[key: string]: Transaction[]})

    console.table(transactionGroup)

    return (
        <TableContainer component={Paper}>
          {loading && <CircularProgress />}
          {error && <Alert severity="error">{error.message}</Alert>}
            <Table aria-label="transaksjonstabell">
              <TableHead>
                <TableRow>
                  <TableCell>Dato</TableCell>
                  <TableCell align="right">Beløp</TableCell>
                  <TableCell align="right">Beskrivelse</TableCell>
                  <TableCell align="right">Gebyr</TableCell>
                  <TableCell align="right">Renter</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.values(transactionGroup).map((transactions) => {
                    const transaction = transactions[0]
                    const interest = transactions.filter(t => t.transactionType === TransactionTransactionTypeEnum.IncurredInterest).reduce((acc, t) => acc + parseFloat(t.amount as any as string), 0)
                    const fee = transactions.filter(t => t.transactionType === TransactionTransactionTypeEnum.InvoiceFee).reduce((acc, t) => acc + parseFloat(t.amount as any as string), 0)
                    const amount = transactions.reduce((acc, t) => acc + Math.abs(parseFloat(t.amount as any as string)), 0)
                  const date = new Date(transaction.transactionDate)
                  const dateString = `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`
                  console.log(amount)
                  return (
                      <TableRow
                        key={transaction.transactionID}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row">
                          {dateString}
                        </TableCell>
                        <TableCell align="right"><FormattedCurrency round={true}>{amount}</FormattedCurrency></TableCell>
                        <TableCell align="right">{mapTypeToDescription(transaction.transactionType)}</TableCell>
                        <TableCell align="right"><FormattedCurrency round={true}>{fee}</FormattedCurrency></TableCell>
                        <TableCell align="right"><FormattedCurrency round={true}>{interest}</FormattedCurrency></TableCell>
                      </TableRow>
                )})}
              </TableBody>
            </Table>
        </TableContainer>
    )
}
*/